/* ===========================================================
   GODIAG 改版 · 三个交互效果（原生实现）

   参考 ui.aceternity.com 的三个组件，但【不是搬代码】——
   那是 React + Framer Motion 的库，往一个 2065 件商品的
   Shopify 店里塞一套 React 运行时不划算。这里只取效果思路，
   用原生重写，总共不到 6KB、零依赖。

     Tracing Beam    → 信号走线：随滚动点亮的一条竖线
     Stateful Button → 加购按钮的 处理中 / 已加入 状态
     Card Spotlight  → 卡片上跟着光标的一团高光

   为什么只挑这三个：这个站的调性是「诊断仪表盘」，卖的是
   两三千美元的专业设备。流星、极光、星空、3D 翻卡那类
   放上来会显得不正经，而且都很重。这三个都是【功能性】的——
   走线告诉你读到哪了，状态按钮告诉你加购成功了，
   高光告诉你光标在哪张卡上。

   三条共同纪律：
     ① prefers-reduced-motion 一律不启用
     ② 只在有精确指针的设备上跑高光（手机没有光标，跑了也白跑）
     ③ 所有效果失败都不影响页面本身——纯增强，不接管任何原有行为
   =========================================================== */
(function () {
  'use strict';

  if (window.__bxFx) return;
  window.__bxFx = true;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* =========================================================
     一、信号走线（Tracing Beam）

     原组件是一条贴着正文的竖线，随滚动"点亮"到当前位置，
     顶端有个发光的珠子。这里做成同样的行为，但用一个
     absolute 元素而不是 SVG path：
     线是直的，SVG 在这里只是徒增复杂度。

     ⚠️ 用 absolute 跟着文档滚，不用 fixed 贴视口：
     fixed 会和左下角那颗常驻旋钮（x 18–122）打架。
     absolute 的线跟着内容走，滚过去就过去了，不占视口。

     只在够宽的屏上出现——窄屏左边没有空白留给它，
     硬塞会压到正文。
     ========================================================= */
  function initBeam() {
    if (RM.matches) return;
    var host = document.querySelector('.bx-main');
    if (!host || host.querySelector('.bx-beam')) return;
    if (!window.matchMedia('(min-width: 1180px)').matches) return;

    var beam = document.createElement('div');
    beam.className = 'bx-beam';
    beam.setAttribute('aria-hidden', 'true');   // 纯装饰，不进无障碍树
    beam.innerHTML = '<i class="bx-beam-lit"></i><i class="bx-beam-bead"></i>';
    host.appendChild(beam);

    var lit = beam.querySelector('.bx-beam-lit');
    var bead = beam.querySelector('.bx-beam-bead');
    var raf = 0;

    function paint() {
      raf = 0;
      var r = host.getBoundingClientRect();
      var vh = window.innerHeight;
      /* 进度 = 视口中线在这块区域里走了多远。
         用中线而不是顶边：用顶边的话，区块刚露头进度就已经不是 0 了。 */
      var mid = vh / 2 - r.top;
      var p = Math.max(0, Math.min(1, mid / r.height));
      lit.style.height = (p * 100) + '%';
      bead.style.top = (p * 100) + '%';
      /* 完全走完就把珠子淡掉，免得它停在末尾像卡住了 */
      bead.style.opacity = (p > 0.002 && p < 0.998) ? '1' : '0';
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(paint); }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();
  }

  /* =========================================================
     二、加购状态按钮（Stateful Button）

     点击 → 处理中 → 已加入。原组件是自己控制异步流程；
     这里【不能】那么做：加购是主题自己的表单逻辑（含规格、
     数量、购物车抽屉），接管它等于把那一套重写一遍。

     所以只做【观察】：点击后进入"处理中"，然后等两个信号之一——
       · 购物车角标数字变了
       · 购物车抽屉打开了
     哪个先到都算成功。都没等到就超时复位，绝不把按钮永久卡住
     （一个卡在"处理中"的加购按钮，比没有状态反馈糟得多）。
     ========================================================= */
  function cartCount() {
    var el = document.querySelector('[data-yh-wishlist-count], .yh-tool--cart [data-count], .cart-count-bubble span, #cart-icon-bubble .cart-count-bubble');
    if (el) {
      var n = parseInt((el.getAttribute('data-count') || el.textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(n)) return n;
    }
    return null;
  }
  function drawerOpen() {
    var d = document.querySelector('cart-drawer, .cart-drawer');
    if (!d) return false;
    return d.classList.contains('active') || d.classList.contains('is-open') ||
           d.getAttribute('aria-hidden') === 'false' || d.hasAttribute('open');
  }

  function initAtc(btn) {
    if (btn.dataset.bxFxAtc) return;
    btn.dataset.bxFxAtc = '1';

    btn.addEventListener('click', function () {
      if (btn.disabled || btn.dataset.bxState) return;
      var before = cartCount();
      var t0 = Date.now();
      btn.dataset.bxState = 'busy';

      var timer = setInterval(function () {
        var now = cartCount();
        var done = (before !== null && now !== null && now !== before) || drawerOpen();
        if (done) {
          clearInterval(timer);
          btn.dataset.bxState = 'done';
          /* 停留 1.6 秒再复位——够看清，又不会挡住第二次加购 */
          setTimeout(function () { delete btn.dataset.bxState; }, 1600);
        } else if (Date.now() - t0 > 6000) {
          /* 超时：什么都没等到就安静复位。宁可没有成功提示，
             也不能让按钮永远停在"处理中" */
          clearInterval(timer);
          delete btn.dataset.bxState;
        }
      }, 120);
    }, true);
  }

  /* =========================================================
     三、卡片光标高光 —— 【已撤除】2026-09-07

     它写在 [data-bx-spot]::after 上，而 .bx-route 的 ::after
     早就是 hover 时那块斜切滑入的橙色填充。一个元素只有一个 ::after，
     高光把橙填充顶掉之后，配着橙底写的近黑标题就压在深色玻璃卡上，
     1.12:1，鼠标一放上去字就基本没了。
     甲方两次说「看不清楚、很奇怪、很不好用」，指的就是这个。

     ⚠️ 别再加回来。要做同类效果只能新开真实子元素，不能抢伪元素。
     ========================================================= */

  /* ---------- 启动 ---------- */
  function boot() {
    /* 信号走线 9/29 撤掉：用户要把它「合并到右边的滑动条」，全站滚动条已换成品牌样式
       （godiag-dark-skin.liquid「图 3 · 右边的滚动条」）。函数留着，要恢复把这一行加回来即可。
    try { initBeam(); } catch (e) {} */
    try {
      Array.prototype.forEach.call(
        document.querySelectorAll('.pdp__atc, [data-pdp-sticky-add], [name="add"]'),
        initAtc);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // 主题编辑器改设置会重渲染 section，重新挂一次
  document.addEventListener('shopify:section:load', boot);
})();
